import React from 'react';

import ReactDOM from 'react-dom/client';

import App from './App';

import { BrowserRouter } from 'react-router-dom'; // Asegúrate de que esté aquí

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(

  <React.StrictMode>

    <BrowserRouter> {/* Debe envolver toda la app */}

      <App />

    </BrowserRouter>

  </React.StrictMode>

);